module.exports = __webpack_public_path__ + "img/icon10.e2f26bd5.png";